export default __webpack_public_path__ + "static/media/Conzi-100-ml-ban.01d76893.jpg";